var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.927 6.914a2 2 0 0 1 2.127 2.802L25.78 30.16a2 2 0 0 1-3.37.439l-2.835-3.47-.286.325A37.853 37.853 0 0 0 10 52.349c0 20.987 17.013 38 38 38s38-17.013 38-38h10c0 26.51-21.49 48-48 48s-48-21.49-48-48c0-12.71 5.152-24.42 13.217-33.007l-4.595-5.626a2 2 0 0 1 1.244-3.242l23.061-3.56z",
    fill: "#B4321E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#D4382A",
    transform: "rotate(-8 48.278 9.33)",
    x: 45.278,
    y: 0.33,
    width: 6,
    height: 18,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#D4382A",
    transform: "rotate(10 61.653 10.319)",
    x: 58.653,
    y: 1.319,
    width: 6,
    height: 18,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#B4321E",
    transform: "rotate(32 73.94 16.045)",
    x: 70.94,
    y: 7.045,
    width: 6,
    height: 18,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#B4321E",
    transform: "rotate(55 84.362 26.497)",
    x: 81.362,
    y: 17.497,
    width: 6,
    height: 18,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#B4321E",
    transform: "rotate(88 91.001 40.42)",
    x: 88.001,
    y: 31.419,
    width: 6,
    height: 18,
    rx: 3
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#D4382A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.176 62.477c-.448 0-.837-.144-1.168-.432a1.399 1.399 0 0 1-.496-1.104c0-.234.053-.48.16-.736l8.064-17.824.352.704h-9.792c-.427 0-.784-.144-1.072-.432a1.456 1.456 0 0 1-.432-1.072c0-.405.144-.746.432-1.024a1.485 1.485 0 0 1 1.072-.416h11.36c.47 0 .87.144 1.2.432.33.288.496.656.496 1.104 0 .256-.053.502-.16.736l-8.544 19.04c-.128.32-.33.571-.608.752a1.557 1.557 0 0 1-.864.272zM65 59.373c.427 0 .784.144 1.072.432.288.288.432.646.432 1.072 0 .427-.144.78-.432 1.056A1.485 1.485 0 0 1 65 62.35H53.768c-.47 0-.843-.138-1.12-.416-.277-.277-.416-.65-.416-1.12 0-.426.15-.81.448-1.152l7.136-7.712c.917-.98 1.627-1.952 2.128-2.912.501-.96.752-1.802.752-2.528 0-1.173-.352-2.122-1.056-2.848-.704-.725-1.632-1.088-2.784-1.088-.49 0-.987.112-1.488.336a6.01 6.01 0 0 0-2.544 2.192c-.213.3-.427.491-.64.576a1.638 1.638 0 0 1-.608.128c-.405 0-.773-.144-1.104-.432-.33-.288-.496-.624-.496-1.008 0-.298.096-.586.288-.864.192-.277.437-.565.736-.864a8.017 8.017 0 0 1 1.712-1.552 8.859 8.859 0 0 1 2.128-1.072 6.78 6.78 0 0 1 2.208-.384c1.408 0 2.63.278 3.664.832a5.888 5.888 0 0 1 2.4 2.336c.565 1.003.848 2.187.848 3.552 0 1.152-.347 2.427-1.04 3.824-.693 1.398-1.659 2.768-2.896 4.112l-4.96 5.408-.352-.32H65z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFind);
export default __webpack_public_path__ + "static/media/find.c0a9a5d569ba3dfc1d799f1a4d906679.svg";
export { ForwardRef as ReactComponent };